import { IEmployee } from "../../globals/interfaces";

export default function useEmployees (employees: Array<IEmployee>, jobTitlesMap: Record<string, string>) {
    return employees.map(employee => ({
        ...employee,
        s_job_title: jobTitlesMap[employee.i_job_id]
    }));
}